/**
 * Organizational Plan of Record (assembled PoR instrument UI).
 * Mounted under Prioritization (`PRIORITIZATION_*`) and under Planning (`PLANNING_*`) with the same pages.
 */
export const PRIORITIZATION_PLAN_INSTRUMENT_PATH = '/prioritization/plan-of-record' as const;
export const PLANNING_PLAN_INSTRUMENT_PATH = '/planning/plan-of-record' as const;

/** Build `/…/instrument/:porId[/subpath]` for a known base segment. */
export function planInstrumentHref(basePath: string, porId: string, subpath = ''): string {
  const s = subpath.replace(/^\//, '');
  const base = `${basePath.replace(/\/$/, '')}/${porId}`;
  return s ? `${base}/${s}` : base;
}

/** Default (Prioritization) workspace path — use `usePlanInstrumentNav` inside the instrument shell. */
export function planInstrumentPorPath(porId: string, subpath = ''): string {
  return planInstrumentHref(PRIORITIZATION_PLAN_INSTRUMENT_PATH, porId, subpath);
}

/** Base of the plan-cycle narrative subpage (unified PoR surface, DEP-026). */
export function planNarrativeBasePath(cycleId: string): string {
  return `/planning/plans/${cycleId}/narrative`;
}

/**
 * Given a standalone instrument URL (`${basePath}/${porId}[/segment...]`),
 * return the segment after the record id (`''` for the index). Used to
 * preserve the face (synopsis, official, section/…) when a cycle-linked
 * record's standalone URL redirects to the plan's narrative subpage.
 * Returns null when the pathname is not under this record's standalone base.
 */
export function instrumentSubpathFromPathname(
  pathname: string,
  basePath: string,
  porId: string,
): string | null {
  const base = `${basePath.replace(/\/$/, '')}/${porId}`;
  if (pathname === base) return '';
  if (pathname.startsWith(`${base}/`)) return pathname.slice(base.length + 1).replace(/\/$/, '');
  return null;
}
